import React, { useState } from "react";
import { Container, Button, Form, Row, Col } from "react-bootstrap";
import img from "../../../assets/images/contact-image.png";
import { Spring } from "react-spring/renderprops";
import { useForm } from "react-hook-form";

const QuoteOwnerEmail = ({ setStep, roofData, setRoofData }) => {
  const { register, handleSubmit, errors } = useForm();

  const submit = async ({ email }) => {
    setRoofData({
      ...roofData,
      email,
    });
    setStep(6);
  };

  return (
    <>
      <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {(props) => (
          <form onSubmit={handleSubmit(submit)}>
            <Container style={props} className="multi-form-step-section">
              <span>
                {" "}
                <div>
                  <img src={img} className="toast-image" alt="Helper Profile" />
                </div>
                <h5> Where Can We Send Your Solar Quote?</h5>
              </span>

              <div className=" solar-address ">
                <form>
                  <Row>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="sunroof-input-label">
                          Email
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email address"
                          ref={register({ required: true })}
                          name="email"
                          defaultValue={roofData?.email}
                          className="form-control sunroof-input"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Button
                    type="submit"
                    className="mx-auto d-block mt-4 own-home-btn sunroof-primary-btn   "
                  >
                    Continue
                  </Button>
                </form>
              </div>
            </Container>
          </form>
        )}
      </Spring>
    </>
  );
};

export default QuoteOwnerEmail;
